
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","d":"M11.8 1v3.6a1.8 1.8 0 001.8 1.8h3.6m-9 .9H6.4m7.2 3.6H6.4m7.2 3.6H6.4M12.7 1H4.6a1.8 1.8 0 00-1.8 1.8v14.4A1.8 1.8 0 004.6 19h10.8a1.8 1.8 0 001.8-1.8V5.5L12.7 1z"}})])
          )
        }
      }
    